/**
 * Copyright (c) 2025-2026 Four Hour Window LLC
 * All rights reserved.
 * 
 * This source code is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import React from 'react';

// Helper function to get status badge color
 const getStatusBadgeColor = (status: string, type: 'financial' | 'fulfillment') => {
  if (type === 'financial') {
    switch (status?.toLowerCase()) {
      case 'paid': return { background: '#d4edda', color: '#155724', border: '#c3e6cb' };
      case 'pending': return { background: '#fff3cd', color: '#856404', border: '#ffeaa7' };
      case 'refunded': return { background: '#f8d7da', color: '#721c24', border: '#f5c6cb' };
      case 'voided': return { background: '#e2e3e5', color: '#383d41', border: '#d6d8db' };
      default: return { background: '#e9ecef', color: '#6c757d', border: '#dee2e6' };
    }
  } else {
    switch (status?.toLowerCase()) {
      case 'fulfilled': return { background: '#d4edda', color: '#155724', border: '#c3e6cb' };
      case 'partial': return { background: '#fff3cd', color: '#856404', border: '#ffeaa7' };
      case 'unfulfilled': return { background: '#f8d7da', color: '#721c24', border: '#f5c6cb' };
      case 'partially_fulfilled' : return { background: 'rgb(255, 214, 164)', color: '#333333', border: 'rgb(255, 214, 164)' };
      case 'in_progress' : return { background: '#cdeef6', color: '#333333', border: '#cdeef6' };
      default: return { background: '#e9ecef', color: '#6c757d', border: '#dee2e6' };
    }
  }
};

// Helper function to render status badge
export const renderStatusBadge = (status: string, type: 'financial' | 'fulfillment'): JSX.Element => {
  const styles = getStatusBadgeColor(status, type);
  console.log('BADGE TYPE = ',type, status)

  if(status.toLocaleLowerCase() === 'partially_fulfilled'){
    status = 'Partially Fulfilled';
  }
  if(status.toLocaleLowerCase() === 'in_progress'){
     status = 'In Progress';
  }
  return (
    <span 
      className={`status-badge ${type}-status`} 
      style={{
        ...styles,
        padding: '2px 6px',
        borderRadius: '4px',
        fontSize: '12px',
        fontWeight: 'bold',
        border: `1px solid ${styles.border}`,
        textTransform: 'capitalize' as const
      }}
    >
      {status || 'unknown'}
    </span>
  );
};

// Helper function to render shipping link badge
export const renderShippingBadge = (printfulShipping: any, orderNumber?: string): JSX.Element | null => {
    console.log('printfulShippingInfo ',printfulShipping)
  console.log(`=== RENDER SHIPPING BADGE DEBUG for Order ${orderNumber} ===`);
  console.log('printfulShipping:', printfulShipping);
  console.log('Has trackingUrl:', !!(printfulShipping?.trackingUrl));
  console.log('Has trackingNumber:', !!(printfulShipping?.trackingNumber));
  
  if (!printfulShipping || !printfulShipping.trackingUrl) {
    return null;
  }

  const isShipped = printfulShipping.shipped || printfulShipping.status === 'shipped';
  const styles = {
    background: isShipped ? '#e8f5e8' : '#fff3cd',
    color: isShipped ? '#2e7d32' : '#856404',
    border: isShipped ? '1px solid #c8e6c9' : '1px solid #ffeaa7'
  };

  return (
    <a 
      href={printfulShipping.trackingUrl} 
      target="_blank" 
      rel="noopener noreferrer"
      style={{ textDecoration: 'none' }}
    >
      <span 
        className="status-badge shipping-status" 
        style={{
          ...styles,
          padding: '2px 6px',
          borderRadius: '4px',
          fontSize: '12px',
          fontWeight: 'bold',
          textTransform: 'capitalize' as const,
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '2px'
        }}
        title={`Track shipment: ${printfulShipping.trackingNumber || 'Click to track'} via ${printfulShipping.carrier || 'carrier'}`}
      >
        Track
        {printfulShipping.trackingNumber && (
          <span className="tracking-number">
            #{printfulShipping.trackingNumber.slice(-4)}
          </span>
        )}
      </span>
    </a>
  );
};